'use client';

import { useQuery } from '@tanstack/react-query';
import { HOUSEHOLD_ACCOUNTS_KEY } from './queryKeys';
import { getHouseholdAccounts } from './views';

export { HOUSEHOLD_ACCOUNTS_KEY };

export function useHouseholdAccounts(enabled = true) {
  return useQuery({
    queryKey: HOUSEHOLD_ACCOUNTS_KEY,
    queryFn: getHouseholdAccounts,
    enabled,
    retry: false,
  });
}
